import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import UserSelect from '../../../common/forms/select/UserSelect';

export const FreeOfChargeRuleForm = ({ handleSubmit, loading }) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem>
          <Label>
            <Field
              name="active"
              id="active"
              component="input"
              type="checkbox"
            />{' '}
            Activo{' '}
          </Label>
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Usuarios Incluidos: ">
          <Field name="userList" component={UserSelect} isMulti />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );
};

FreeOfChargeRuleForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

FreeOfChargeRuleForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: !state.SalesUnit.FreeOfChargeRule.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'FreeOfChargeRuleForm',
})(FreeOfChargeRuleForm);

export default connect(mapStateToProps)(formComponent);
